import { admitad } from './admitad'
import { auth } from './auth'
import { user } from './user'
import { article } from './article'
import { block } from './block'
import { contacts } from './contacts'
import { richHtmlBlock } from './rich-html-block'
import { mailing } from './mailing'
import { video } from './video'
import { fixed } from './fixed'
import { star } from './star'
import { statistic } from './statistic'
import { distribution } from './distribution'
import { socialDistribution } from './social-distribution'
import { articleVideo } from './article-video'
import { podcastEpisode } from './podcast-episode'
import { podcast } from './podcast'
import { transcribation } from './transcribation'
import { podcastDistribution } from './podcast-distribution'
import { dictionaries } from './dictionaries'
import { brandWidget } from './brand-widget'
import { audioMessage } from './audio-message'
import { imageTransform } from './image-transform'
import { articleScroll } from './article-scroll'
import { advSwitch } from './advSwitch'
import { advTag } from './advTag'
import { articleBlocks } from './articleBlocks'
import { author } from './author'
import { award } from './award'
import { blocking } from './blocking'
import { changeHistory } from './changeHistory'
import { city } from './city'
import { comment } from './comment'
import { contact } from './contact'
import { contest } from './contest'
import { embed } from './embed'
import { expert } from './expert'
import { fact } from './fact'
import { feature } from './feature'
import { file } from './file'
import { gallery } from './gallery'
import { geo } from './geo'
import { good } from './good'
import { image } from './image'
import { interest } from './interest'
import { issue } from './issue'
import { mediaLibrary } from './mediaLibrary'
import { photo } from './photo'
import { planCompare } from './planCompare'
import { poll } from './poll'
import { popblock } from './popblock'
import { popup } from './popup'
import { recipe } from './recipe'
import { section } from './section'
import { support } from './support'
import { tag } from './tag'
import { technical } from './technical'
import { test } from './test'
import { videoPartner } from './videoPartner'
import { yandexGpt } from './yandexGpt'
import { videoWidget } from './videoWidget'
import { parser } from './parser'
import { news } from './news'
import { brand } from './brand'
import { userModeration } from './userModeration'
import { topic } from './topic'
import { topicInterest } from './topic-interest'
import { articleRequest } from './article-request'
import { storyJury } from './storyJury'
import { audio } from './audio'
import { articleAudio } from './article-audio'
import { teaser } from './teaser'
import { playlist } from './playlist'
import { unpublish } from './unpublish'
import { mascot } from './mascot'
import { quote } from './quote'
import { company } from './company'
import { calendar } from './calendar'
import { version } from './version'

const SiriusAPI = {
  admitad,
  auth,
  user,
  article,
  block,
  contacts,
  richHtmlBlock,
  mailing,
  video,
  fixed,
  star,
  statistic,
  distribution,
  socialDistribution,
  articleVideo,
  podcastEpisode,
  podcast,
  transcribation,
  podcastDistribution,
  dictionaries,
  brandWidget,
  audioMessage,
  imageTransform,
  articleScroll,
  advSwitch,
  advTag,
  articleBlocks,
  author,
  award,
  blocking,
  changeHistory,
  city,
  comment,
  contact,
  contest,
  embed,
  expert,
  fact,
  feature,
  file,
  gallery,
  geo,
  good,
  image,
  interest,
  issue,
  mediaLibrary,
  photo,
  planCompare,
  poll,
  popblock,
  popup,
  recipe,
  section,
  support,
  tag,
  technical,
  test,
  videoPartner,
  yandexGpt,
  videoWidget,
  parser,
  news,
  brand,
  audio,
  playlist,
  articleAudio,
  userModeration,
  topic,
  topicInterest,
  articleRequest,
  storyJury,
  teaser,
  unpublish,
  mascot,
  quote,
  company,
  calendar,
  version,
}

export default SiriusAPI
